module.exports = __webpack_public_path__ + "static/media/shiv.f161b485.png";